import { writable, derived } from "svelte/store";
import translations from "./translations";

export const dict = writable();
export const locale = writable(window.localStorage.getItem("wglang") || "de");

$: dict.set(translations);

// Make method global so language switcher can access it
window.setLanguage = (lang) => {
  locale.set(lang);
};

const localizedDict = derived([dict, locale], ([$dict, $locale]) => {
  if (!$dict || !$locale) return;
  return $dict[$locale];
});

const getMessageFromLocalizedDict = (id, localizedDict) => {
  const splitId = id.split(".");
  let message = { ...localizedDict };
  splitId.forEach((partialId) => {
    message = message[partialId];
  });
  return message;
};

const createMessageFormatter = (localizedDict) => (id) =>
  getMessageFromLocalizedDict(id, localizedDict);

export const t = derived(localizedDict, ($localizedDict) => {
  return createMessageFormatter($localizedDict);
});
